import React, { useEffect, useState } from "react";
// import styled from "styled-components";
import axios from "axios";
import './style.css'

const PrivacyPolicy = () => {
	const [data, setData] = useState([]);
	const getData = async () => {
		try{
			const res = await axios.get(`${process.env.REACT_APP_BASE_DOMAIN}/app/member/auth-terms/public/PRIVACY_POLICY`);
			setData(res.data.data.content);
		} catch(err){
			console.log(err)
		}
	}
	useEffect(()=> {
		getData();
	}, [])

	return (
		<div dangerouslySetInnerHTML={{__html : data}} className="test"></div>
	)
}
// const Tmp = styled.div`
// 	background-color: white;
// 	min-height: 100vh;
// 	height: 100%;

// 	.ttmp{
// 		margin-top: 24px !important;
// 		margin-bottom: 24px !important;
// 		margin-right: 16px !important;
// 		margin-left: 16px !important;
// 	}
// `
export default PrivacyPolicy;